import type { Screen } from "../state/screen";
import type { ContractType } from "../types";

/** Maps a contract task type to the task screen that resolves it. */
export function taskScreenFor(type: ContractType): Screen {
  switch (type) {
    case "log_analysis":
      return "log_analysis";
    case "network_map":
      return "network_map";
    case "phishing":
      return "phishing";
    case "report_builder":
      return "report_builder";
    default: {
      const exhaustive: never = type;
      return exhaustive;
    }
  }
}
